import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { MsisdnService } from '../../../shared/msisdn/msisdn.service';
import { Msisdn } from '../../../shared/msisdn/msisdns';
import { Observable } from 'rxjs/Observable';
import { MatSelectChange } from '@angular/material';
import { Ng1IpInfoService } from '../../../shared/ng1/ng1-ip-info.service';
import { NotificationService } from '../../../shared/notification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'cc-creator-phone-numbers',
  templateUrl: '../phone-numbers.component.html',
  styleUrls: ['../phone-numbers.component.scss']
})
export class CreatorPhoneNumbersComponent implements OnInit {
  public addForm: FormGroup;
  public numbers = {
    campaignsMsisdns: [],
    mainCallerId: {},
    eeaCallerId: {},
    restricted: false
  } as any;
  public msisdns: Observable<Msisdn[]>;

  @Input() numberId;
  @Output() setRestricted = new EventEmitter();
  @Output() setMainPhoneNumber = new EventEmitter();
  @Output() setMainEeaPhoneNumber = new EventEmitter();
  @Output() changedListPhoneNumbers = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private msisdnService: MsisdnService,
    private router: Router,
    private ng1IpInfoService: Ng1IpInfoService,
    private notify: NotificationService
  ) {}

  ngOnInit() {
    this.addForm = this.createAddForm();
    this.prepareMsisdnsList().subscribe(numbers => {
      this.setInitPhoneNumbers(numbers);
    });
  }

  createAddForm() {
    return this.fb.group({
      msisdnId: null
    });
  }

  checkMainPhoneNumbers() {
    this.numbers.campaignsMsisdns = this.numbers.campaignsMsisdns.map(number => {
      return {
        ...number,
        mainPhoneNumber: this.numbers.mainCallerId.id === number.id,
        mainEeaPhoneNumber: this.numbers.eeaCallerId.id === number.id
      };
    });
  }

  prepareMsisdnsList(): any {
    return (this.msisdns = this.msisdnService
      .msisdns()
      .pipe(
        map((msisdns: any) =>
          msisdns.filter(
            msisdn => !this.numbers.campaignsMsisdns.find(campaignsMsisdn => campaignsMsisdn.id === msisdn.id)
          )
        )
      ));
  }

  setInitPhoneNumbers(numbers) {
    const firstEeaPhoneNumber = this.numberId
      ? numbers.find((msisdn: Msisdn) => msisdn.id === Number(this.numberId))
      : numbers.find((msisdn: Msisdn) => msisdn.eea);
    this.onSelectPhoneNumber({ value: firstEeaPhoneNumber } as any);
    this.onSetMainPhoneNumber(firstEeaPhoneNumber);
    this.onSetMainEeaPhoneNumber(firstEeaPhoneNumber);
  }

  onSetMainPhoneNumber(number) {
    this.numbers.mainCallerId = number;
    this.checkMainPhoneNumbers();
    this.setMainPhoneNumber.next(this.numbers.mainCallerId);
  }

  onSetMainEeaPhoneNumber(number) {
    this.numbers.eeaCallerId = number;
    this.checkMainPhoneNumbers();
    this.setMainEeaPhoneNumber.next(this.numbers.eeaCallerId);
  }

  onSelectPhoneNumber(select: MatSelectChange) {
    this.addForm.get('msisdnId').setValue(null);
    this.numbers.campaignsMsisdns.push(select.value);
    this.changedListPhoneNumbers.next(this.numbers.campaignsMsisdns);
    this.prepareMsisdnsList();
  }

  onChangePhoneNumbers(restricted) {
    this.numbers.restricted = restricted;
    this.setRestricted.next(restricted);
  }

  onRemovePhoneNumber(numberId) {
    if (this.numbers.mainCallerId.id === numberId) {
      this.notify.open('PHONE_NUMBERS.CREATOR.MAIN_REQUIRED', {}, this.notify.getDefaultCloseAction());
      return;
    }

    if (this.numbers.eeaCallerId.id === numberId) {
      this.notify.open('PHONE_NUMBERS.CREATOR.EEA_REQUIRED', {}, this.notify.getDefaultCloseAction());
      return;
    }

    this.changedListPhoneNumbers.next(this.numbers.campaignsMsisdns);
    this.numbers.campaignsMsisdns.splice(this.numbers.campaignsMsisdns.findIndex(el => el.id === numberId), 1);
    this.prepareMsisdnsList();
  }

  gotoNewNumber() {
    const code = this.ng1IpInfoService.getCountry();
    this.router.navigate(['get-new-number', 'pricing', code]);
  }
}
